import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Preachin\' It At Church',
  date: new Date(2023, 4, 14),
  img: '/img/priest.jpeg',
  tracks: [
    {
      title: 'Smokescreen',
      src: '/songs/2023-05-14/smokescreen.mp3',
    },
    {
      title: 'Fill \'er Up',
      src: '/songs/2023-05-14/fill_er_up.mp3',
    },
    {
      title: 'Martin\'s Solo (Rock & Roll is Good for the Soul',
      src: '/songs/2023-05-14/martins_solo.mp3',
    },
    {
      title: 'I knew You Before',
      src: '/songs/2023-05-14/i_knew_you_before.mp3',
    },
    {
      title: 'Be a Winner',
      src: '/songs/2023-05-14/be_a_winner.mp3',
    },
    {
      title: 'Scruffy Little Puppy',
      src: '/songs/2023-05-14/scruffy_little_puppy.mp3',
    },
    {
      title: 'Deepest Recesses',
      src: '/songs/2023-05-14/deepest_recesses.mp3',
    },
    {
      title: 'Te Lo Doy',
      src: '/songs/2023-05-14/te_lo_doy.mp3',
    },
    {
      title: 'Skyline',
      src: '/songs/2023-05-14/skyline.mp3',
    },
    {
      title: 'I Dig It',
      src: '/songs/2023-05-14/i_dig_it.mp3'
    },
    {
      title: 'All you can eat Mother\'s Day Buffet',
      src: '/songs/2023-05-14/all_you_can_eat_mothers_day_buffet.mp3',
    },
    {
      title: 'Sucked Down a Wormhole (Lost in Space)',
      src: '/songs/2023-05-14/sucked_down_a_wormhole_lost_in_space.mp3',
    },
  ]
}
export default album;